import { Flex, Tag, Typography } from '@iheartjane/reefer';
import type { ProductCategory } from '@iheartjane/types';
import { sentenceCase } from '@iheartjane/utils';
import { clsx } from 'clsx';

import { useCustomLanguage } from '@jane/bloom/hooks/useCustomLanguage';

import styles from './productDetails.module.css';

type DetailsBoxProps = {
  description: string;
  percentage?: number;
};

function DetailsBox({ description, percentage }: DetailsBoxProps) {
  return (
    <Tag
      background="grays-black"
      color="grays-white"
      label={`${description} ${percentage}%`}
    />
  );
}

function CategoryBox({ category }: { category: ProductCategory }) {
  const customLanguage = useCustomLanguage();

  return (
    <div
      className={clsx(styles['productDetailTag'], {
        [styles['cbdTag']]: category === 'cbd',
        [styles['hybridTag']]: category === 'hybrid',
        [styles['indicaTag']]: category === 'indica',
        [styles['sativaTag']]: category === 'sativa',
      })}
    >
      <Tag
        background="inherit"
        color="inherit"
        label={
          category === 'cbd'
            ? customLanguage.lineageLabels?.[category] || 'CBD'
            : sentenceCase(customLanguage.lineageLabels?.[category] || category)
        }
      />
    </div>
  );
}

type ProductDetailsProps = {
  category: ProductCategory | null;
  percentageCBD: number;
  percentageTHC: number;
};

export function ProductDetails({
  category,
  percentageCBD,
  percentageTHC,
}: ProductDetailsProps) {
  return (
    <Flex flexDirection="column" data-testid="product-details">
      <Typography mb={8} mt={24} variant="body-bold" color="text-main">
        Details
      </Typography>

      {!percentageCBD && !percentageTHC && !category && (
        <Typography color="text-main">-</Typography>
      )}

      <div className={styles['pdpCardBoxes']}>
        <Flex flexDirection="row" gap={8}>
          {category && <CategoryBox category={category} />}
          {percentageCBD > 0 && (
            <DetailsBox description="CBD" percentage={percentageCBD} />
          )}
          {percentageTHC > 0 && (
            <DetailsBox description="THC" percentage={percentageTHC} />
          )}
        </Flex>
      </div>
    </Flex>
  );
}
